































import {Vue, Component, Prop} from 'vue-property-decorator'
import Accordion from '@/components/proxy/Accordion/Accordion.vue'
import AccordionContent from '@/components/proxy/Accordion/AccordionContent.vue'
import Layout from '@/components/proxy/Layout.vue'
import Img from '@/components/proxy/Image.vue'
import CustomIcon from '@/components/CustomIcon.vue'
import PlanBaseRate from '@/components/subscriptions/PlanBaseRate.vue'
import TimeOverrides from '@/components/TimeOverrides.vue'
import BulkOverrides from '@/components/BulkOverrides.vue'
import DistanceOverrides from '@/components/DistanceOverrides.vue'
import {SubscriptionPlan, Rate, BulkOverride, TimeOverride, DistanceOverride} from '@/lib/kepler/interfaces'

type OverrideArray = TimeOverride[] | BulkOverride[] | DistanceOverride[] | []
type Override = TimeOverride | BulkOverride | DistanceOverride

@Component({
  components: {
    DistanceOverrides,
    BulkOverrides,
    TimeOverrides,
    PlanBaseRate,
    CustomIcon,
    Img,
    Layout,
    AccordionContent,
    Accordion,

  },
})
export default class PlanDetailRates extends Vue {
  @Prop() public plan!: SubscriptionPlan
  @Prop({
    type: String,
  }) public mode!: string
  @Prop({
    type: Array,
    default: () => [],
  }) public rates!: Rate[]
  @Prop({
    type: String,
  }) public color1!: string
  @Prop({
    type: String,
  }) public color2!: string

  public bookingModes(rate?: Rate) {
    let bm = ''
    if (!rate && this.plan) {
      for (const r of this.plan.rates) {
        if (!bm.includes(r.booking_mode)) {
          bm += bm.length > 0 ? ',' + r.booking_mode : r.booking_mode
        }
      }
    } else if (rate) {
      bm = rate.booking_mode
    }
    return bm.split(',')
  }

  public noOverridesRate(rate: Rate) {
    return rate.bulk_overrides.length === 0 && rate.distance_overrides.length === 0 && rate.time_overrides.length === 0
  }

  public get textGradient() {
    return {
      color: this.color1,
      background: `-webkit-linear-gradient(45deg, ${this.color1}, ${this.color2})`,
    }
  }

  public get overrides() {
    const types = ['time', 'distance', 'bulk']
    const rates = this.plan.rates
    const result: Array<{ [type: string]: any[] }> = []
    rates.forEach((rate, i) => {
      result[i] = {}
      types.forEach((type) => {
        const typeOverrides: OverrideArray = rate[type + '_overrides']
        const overrides = typeOverrides.map((a: Override) => ({...a}))
        if (!!overrides?.length) {

          // shitfix for hardcoded ids
          let incremental = 0
          overrides.forEach((override) => {
            override.id += incremental
            incremental++
          })
          // end shitfix

          result[i][type] = overrides
        }

      })
    })
    return result
  }

  public parseMinutes(val: number) {

    const shortMap: { [key: number]: string } = {
      1: this.$t('common.time_units.minute'),
      60: this.$t('common.time_units.hour'),
    }

    const longMap: { [key: number]: string } = {
      1: this.$t('common.time_units.day'),
      7: this.$t('common.time_units.week'),
      30: this.$t('common.time_units.month'),
      60: this.$t('common.time_units.two-month'),
      90: this.$t('common.time_units.quarter'),
      365: this.$t('common.time_units.year'),
    }

    const map = val < 1440 ? shortMap : longMap

    // TODO: finish refactoring
    if (val < 1440) {
      if (map.hasOwnProperty(val)) {
        return map[val]
      } else {
        if (!(val % 60)) {
          return this.$t('common.time_units.hours', {n: val / 60})
        } else {
          return this.$t('common.time_units.minutes', {n: val})
        }
      }
    } else {
      val = val / 1440
      if (map.hasOwnProperty(val)) {
        return map[val]
      } else {
        if (!(val % 30)) {
          return this.$t('common.time_units.months', {n: val / 30})
        } else if (!(val % 7)) {
          return this.$t('common.time_units.weeks', {n: val / 7})
        } else {
          return this.$t('common.time_units.days', {n: val})
        }
      }
    }
  }

}
